import DateInput from '@perpay-web/components/base/DateInput/DateInput';
import { withFormikInputWrapper } from '@perpay-web/components/higher-order/WithFormikInputWrapper/WithFormikInputWrapper';

const FormikDateInput = withFormikInputWrapper(DateInput);

export default FormikDateInput;
